import Vue from 'vue'

import ElementUI, {Loading} from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import api from '@/uilts/api.js';
import tools from '@/uilts/tools';
import App from './App.vue'
import router from './router'
// 导入所有api
import module from '@/api/index'
import upload from '@/components/upload.vue'
import fileUploader from '@/components/fileUploader.vue'



import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)          // 一次性把免费库全部注册

Vue.component('fa-icon', FontAwesomeIcon)   // 起个别名，后面好混用











Vue.component("upload", upload);
Vue.component("fileUploader", fileUploader);


Vue.prototype.$api = api;
import store from './store'

Vue.prototype.$apiAll = module
Vue.prototype.$tools = tools

Vue.prototype.$img = 'http://oa.zhhg.org.cn:8080';


Vue.use(ElementUI, {size: 'small', zIndex: 3000});

Vue.config.productionTip = false


//导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);


function hasPermission(value, el = false) {
    if (!Array.isArray(value)) {
        throw new Error(`需要配置权限，列如 v-permission = '['get']'`)
    }

    const hasAuth = value.findIndex((v) => JSON.parse(window.sessionStorage.getItem('putispermission')).includes(v)) != -1


    if (el && !hasAuth) {
        el.parentNode && el.parentNode.removeChild(el)
    }
    return hasAuth
}


// Vue.prototype.$loading = () => {
//     const loadingInstance = Loading.service({
//         lock: true,
//         text: 'Loading',
//         spinner: 'el-icon-loading',
//         background: 'rgba(0, 0, 0, 0.7)'
//     });
//     return {
//         close: () => {
//             loadingInstance.close();
//         }
//     };
// };
Vue.directive('permission', {
    //el可以取到该节点
    inserted: function (el, bingding) {
        hasPermission(bingding.value, el)
    }
});

Vue.directive('preventReClick', {
    inserted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 2000)
            }
        })
    }
});

Vue.prototype.permission = function (v) {
    let hasAuth = false
    if (!Array.isArray(v)) {
        hasAuth = JSON.parse(window.sessionStorage.getItem('putispermission')).includes(v)
    } else {
        hasAuth = v.findIndex((item) => JSON.parse(window.sessionStorage.getItem('putispermission')).includes(item)) != -1
    }
    return hasAuth
};


Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
                .length)));
        }
    }
    return fmt;
}


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
